import NewWebsiteContent from "page_components/client/websites/NewWebsiteContent";
import NewWebsiteProvider from "context/client/new_website";
import WebsiteAccessDataProvider from "context/client/website_access_data";

const NewWebsites = () => (
  <NewWebsiteProvider>
    <WebsiteAccessDataProvider>
      <NewWebsiteContent />
    </WebsiteAccessDataProvider>
  </NewWebsiteProvider>
);

export default NewWebsites;
